module.exports = __webpack_public_path__ + "assets/img/notifications_bell_transparent.svg";